import React, { useState, useEffect, Fragment, useRef } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { translate, getBlackAsterisk, exists } from "application/functions";
import "moment/locale/es";
import ReactModal from "react-modal";
import SelectDateAppointment from "form/components/date-appointment/select-date-appointment";
import IconCalendar from "assets/img/icon-date-input.png";
import IconDelete from "assets/img/cancel.svg";
import {
  standard_date,
  standard_datetime,
  modalTime,
} from "form/components/date-appointment/modal-styles";
import { contains, isEmpty, isNil, clone, split, includes, map } from "ramda";

export default function DateTimePickerField(props) {
  const {
    field,
    register,
    setSelectValue,
    size,
    locale,
    required,
    errors,
    showDate,
    isSubmitted,
    availability,
    date,
  } = props;

  const mainLocale = split("-", locale)[0];
  moment.locale(mainLocale);

  const [modalIsOpen, setModalOpen] = useState(false);
  const [showDropDown, setShowDropDown] = useState(false);
  const [showDropTop, setShowDropTop] = useState(false);
  const [printDate, setPrintDate] = useState("");

  const topRef = useRef(null);
  const downRef = useRef(null);

  const handleValues = (value, type) => {
    setSelectValue(field, value);
    handleOnPrintDate(false, value);
  };

  const handleOnPrintDate = (isClean, value) => {
    if (!isClean) {
      setPrintDate(value);
    } else {
      setPrintDate("");
    }
  };

  /*   useEffect(() => {
    if(!exists(availability) || (exists(availability) && exists(date) && !includes(date, map(a => moment(a).format("DD/MM/YYYY").toString(), availability)))) {
        setDate(null);
        setPrintDate("");
    }
  }, [availability]); */

  useEffect(() => {
    if (typeof window !== "undefined") {
      ReactModal.setAppElement("body");
    }

    // subscribe event
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEscape, false);
    return () => {
      // unsubscribe event
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEscape, false);
    };
  }, [printDate]);

  /**
   * Se ejecuta cuando "clickas" fuera del div.
   * @param {*} e
   */
  const handleClickOutside = (e) => {
    const className = "rc-time-picker-panel-select";
    const element = e.target;
    const isTimePickerRef =
      element &&
      element.parentNode &&
      element.parentNode.parentNode &&
      element.parentNode.parentNode.classList.contains(className);

    if (isNil(e)) {
      setShowDropTop(false);
      setShowDropDown(false);
      return;
    }

    if (isNil(topRef.current) && isNil(downRef.current) && isTimePickerRef) {
      return;
    }

    if (
      !isNil(topRef.current) &&
      !topRef.current.contains(e.target) &&
      !isTimePickerRef
    ) {
      setShowDropTop(false);
    }
    if (
      !isNil(downRef.current) &&
      !downRef.current.contains(e.target) &&
      !isTimePickerRef
    ) {
      setShowDropDown(false);
    }
  };

  /**
   * Se ejecuta cuando pulsas la tecla "escape".
   * @param {*} e
   */
  const handleEscape = (e) => {
    if (e.keyCode === 27) {
      setShowDropTop(false);
      setShowDropDown(false);
    }
  };

  const openCalendar = (e) => {
    const target = e.target;
    const isDeleteIcon =
      target && target.classList.contains("date__delete-icon");
    if (!isDeleteIcon) {
      const modalSizes = ["md_horizontal", "sm_vertical", "xs_vertical"];
      if (contains(size, modalSizes)) {
        setModalOpen(true);
      } else {
        const element = document.getElementById(`main-field-${field}`);
        const space =
          window.innerHeight - element.offsetTop + element.offsetHeight;
        if (space >= 400) {
          setShowDropDown(true);
        } else {
          setShowDropTop(true);
        }
      }
    } else {
      return;
    }
  };

  // Bloquear la vista de los meses
  const disableYearClick = () => {
    const yearElements = document.getElementsByClassName("rdtSwitch");
    if (yearElements.length === 1) {
      const yearElementLeft = document.getElementsByClassName("rdtSwitch")[0];
      yearElementLeft.addEventListener("click", (e) => e.stopPropagation());
    }

    if (yearElements.length === 2) {
      const yearElementLeft = document.getElementsByClassName("rdtSwitch")[0];
      yearElementLeft.addEventListener("click", (e) => e.stopPropagation());
      const yearElementRight = document.getElementsByClassName("rdtSwitch")[1];
      yearElementRight.addEventListener("click", (e) => e.stopPropagation());
    }
  };

  const closeModal = () => {
    document.getElementsByTagName("body")[0].style.overflow = "auto";
    setModalOpen(false);
  };

  const afterOpenModal = () => {
    document.getElementsByTagName("body")[0].style.overflow = "hidden";
  };

  const deleteCalendar = () => {
    setSelectValue(field, "");
    handleOnPrintDate(true);
  };

  const getCalendar = (isModal) => {
    const buttonComponent = isModal && (
      <button className="date__btn-accept" onClick={() => closeModal()}>
        {translate("field.accept", locale)}
      </button>
    );

    return (
      <div className="datepicker__container">
        <SelectDateAppointment
          handleValues={handleValues}
          locale={mainLocale}
          availability={availability}
          date={date}
        />
        {buttonComponent}
      </div>
    );
  };

  const showDropStyles = () => {
    if (size === "lg_horizontal") return { width: "67%" };
    if (size === "full_horizontal") return { width: "54%" };
    if (size === "ultrawide") return { width: "54%" };
  };

  const fieldRequired = translate("field.required", locale);

  const hasErrors =
    !isNil(errors) && !isNil(errors[field]) && !isEmpty(errors[field]);

  return (
    <Fragment>
      <div style={{ display: "none" }}>
        <input
          type="text"
          ref={register({ required: required })}
          name={field}
        />
      </div>
      <div
        className="field-creator__field-container"
        style={{
          display: showDate && !isEmpty(availability) ? "inherit" : "none",
        }}
      >
        {/* Standard View */}
        <div
          className={`field-creator__labelfield${hasErrors ? "--error" : ""}`}
        >
          {getBlackAsterisk(required)}
          {translate(`field.${field}`, locale)}
        </div>
        <div
          id={`main-field-${field}`}
          className="date__main-container"
          style={{ display: showDate ? "inherit" : "none" }}
        >
          {showDropTop && (
            <div
              className={"date__droptop"}
              style={showDropStyles()}
              ref={topRef}
            >
              {getCalendar(false)}
            </div>
          )}
          <a className="date__input-btn" onClick={(e) => openCalendar(e)}>
            <div style={{ borderBottom: "1px solid black", height: "27px" }}>
              <span style={{ float: "left" }}>
                {exists(date) ? date.toString() : ""}
              </span>
              <img
                className="date__calendar-icon"
                src={IconCalendar}
                alt="Arrow to scroll"
              />
              <img
                className="date__delete-icon"
                src={IconDelete}
                alt="Arrow to scroll"
                onClick={() => deleteCalendar()}
              />
            </div>
          </a>
          {showDropDown && (
            <div
              className="date__dropdown"
              style={showDropStyles()}
              ref={downRef}
            >
              {getCalendar(false)}
            </div>
          )}
        </div>
        <ReactModal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          onAfterOpen={afterOpenModal}
          style={standard_date}
          ariaHideApp={false}
        >
          {getCalendar(true)}
        </ReactModal>
        {errors[field] && isSubmitted && (
          <div className="forms__error-message">{fieldRequired}</div>
        )}
      </div>
      <div
        className="field-creator__not-available"
        style={{
          display: showDate && isEmpty(availability) ? "inherit" : "none",
        }}
      >
        {translate("field.day.notAvailable", locale)}
      </div>
    </Fragment>
  );
}

DateTimePickerField.propTypes = {
  field: PropTypes.string,
  register: PropTypes.any,
  setSelectValue: PropTypes.func,
  size: PropTypes.string,
  locale: PropTypes.string,
  required: PropTypes.bool,
  isSubmitted: PropTypes.bool,
  errors: PropTypes.any,
  showDate: PropTypes.bool,
  availability: PropTypes.array,
  date: PropTypes.any,
};
